module.exports = __webpack_public_path__ + "img/GH-kyujin-top-h-pa-1sp.35efd207.webp";